import React, { useState } from 'react';
import { isMobileView } from '../ReactiveRender';
import { DialogContent, Dialog } from '@mui/material';
import WarningAmberIcon from '@mui/icons-material/WarningAmber';
import {
  TextFrame,
  TextInput,
  DeleteTitle,
  ButtonsContainer,
  CancelButton,
  ProceedButton,
  TextContent,
  DeleteAssignmentPopupContainer,
  DeleteAssignmentPopupContainerSmall,
  TitleContainer,
  Line141,
  ConfirmSubmit,
  PlagiarismText,
  ScrollableContent,
  CloseIconContainer,
  CloseIconImage,
} from './style';
import tickIcon from '../../static/img/tickpurple.svg';

export default function GeneralPopup(props) {
  const {
    hidePopup,
    buttonText,
    textContent,
    title,
    closeBtnText = 'Cancel',
    confirmationMessage,
    confirmButtonAction,
    smartAnnotation,
    createSmartAnnotationHandler,
    warningMessage,
    cancelPopup,
    icon,
    showCloseIcon = false,
    closeIcon,
    width,
    open = true,
    variant = 'default', // 'default' or 'warning'
  } = props;

  const [annotationTitle, setAnnotationTitle] = useState('');

  const handleInputChange = (event) => {
    setAnnotationTitle(event.target.value);
  };

  const isWarning = variant === 'warning';
  const displayIcon = icon || (isWarning ? null : tickIcon);

  const content = (
    <>
      <TitleContainer variant={variant}>
        <DeleteTitle>
          {isWarning ? (
            <WarningAmberIcon style={{ color: '#ed6c02', fontSize: '24px' }} />
          ) : (
            displayIcon && <img src={displayIcon} />
          )}
          {title}
        </DeleteTitle>
        {showCloseIcon && closeIcon && (
          <CloseIconContainer onClick={() => hidePopup()}>
            <CloseIconImage src={closeIcon} alt="Close" />
          </CloseIconContainer>
        )}
      </TitleContainer>
      <Line141 src="/img/line-14@2x.png" />
      <ScrollableContent>
      {textContent && <TextContent>{textContent}</TextContent>}
      {smartAnnotation && (
        <TextFrame>
          <TextInput onChange={handleInputChange}></TextInput>
        </TextFrame>
      )}
      <ConfirmSubmit>
        {warningMessage && <PlagiarismText>{warningMessage}</PlagiarismText>}
        {confirmationMessage && (
          <PlagiarismText>{confirmationMessage}</PlagiarismText>
        )}
      </ConfirmSubmit>
      </ScrollableContent>

      {!showCloseIcon && (
        <ButtonsContainer>
          <ProceedButton
            onClick={() => (cancelPopup ? cancelPopup() : hidePopup())}
          >
            {closeBtnText}
          </ProceedButton>
          {smartAnnotation ? (
            <CancelButton
              onClick={() => createSmartAnnotationHandler(annotationTitle)}
            >
              {buttonText}
            </CancelButton>
          ) : (
            <CancelButton onClick={() => confirmButtonAction()}>
              {buttonText}
            </CancelButton>
          )}
        </ButtonsContainer>
      )}
    </>
  );

  return (
    <Dialog open={open} onClose={() => hidePopup()}>
      <DialogContent>
        {isMobileView() ? (
          <DeleteAssignmentPopupContainerSmall>
            {content}
          </DeleteAssignmentPopupContainerSmall>
        ) : (
          <DeleteAssignmentPopupContainer width={width}>
            {content}
          </DeleteAssignmentPopupContainer>
        )}
      </DialogContent>
    </Dialog>
  );
}
